/** @format */

import type React from "react";

/** @format */
import logo from "../assets/galaxie_logo.svg";

interface LoadingCircleProps {
  className?: string;
}

const LoadingCircle: React.FC<LoadingCircleProps> = ({ className = "" }) => (
  <img src={logo} alt="loading" className={className} width="1024" height="1024" />
);

export default LoadingCircle;
